import { render, staticRenderFns } from "./pharmacies.vue?vue&type=template&id=3275e355&"
import script from "./pharmacies.vue?vue&type=script&lang=js&"
export * from "./pharmacies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports